import axios from 'axios'
import deviceState from '@/services/device'
const apiUrl = 'https://actapi.mini1.cn/nwxapi/js_config'

let _wxInited = false

const initJsSdk = (jsApiList = []) => {
  if (!window.wx || !deviceState.isWechat) return Promise.reject()
  if (_wxInited) return Promise.resolve()
  return new Promise(async (resolve, reject) => {
    let data = {}
    try {
      const resp = await axios.post(apiUrl, { href: location.href.split('#')[0] })
      if (!resp.data || !resp.data.data || !resp.data.data.appId) { reject(); return }
      data = resp.data.data
    } catch (error) {
      reject(); return
    }
    data.jsApiList = ['updateAppMessageShareData', 'updateTimelineShareData', 'onMenuShareTimeline', 'onMenuShareAppMessage']
    wx.config(data)
    wx.ready(() => {
      resolve()
      _wxInited = true
    })
    wx.error((res) => {
      console.error(res)
      reject()
    })
  })
}

export default {
  /**
   *  初始化微信内的H5分享
   * @param {*} param {
   *  title: '快来一起开黑吧！', // 分享标题，
   *  desc: '超好玩的沙盒游戏尽在《迷你世界》，一起玩呀！', // 分享描述
   *  link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
   *  imgUrl: 'https://image.mini1.cn/d/20210812/7a97786f9445aa232db1c6a6ec0d4cd4.png', // 分享图标
   * }
   */
  async initWxShare(param = {}) {
    await initJsSdk()
    if (wx) {
      wx.checkJsApi({
        jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData'], // 需要检测的JS接口列表，所有JS接口列表见附录2,
        success(res) {
          wx.onMenuShareTimeline(param)
          wx.onMenuShareAppMessage(param)
          wx.updateAppMessageShareData(param)
          wx.updateTimelineShareData(param)
        }
      })
    }
  }
}
